"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const ContentService_1 = __importDefault(require("../ContentService"));
const useClearLastModuleId = () => {
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        const pathname = location.pathname;
        if (/\/modules\/[a-zA-Z0-9]+/.test(pathname)) {
            const pathParts = pathname.split('/');
            const moduleId = pathParts[2];
            if (moduleId === 'new') {
                ContentService_1.default.lastEditedModule = null;
                ContentService_1.default.lastCreatedModule = null;
                return;
            }
            if (moduleId) {
                ContentService_1.default.lastEditedModule = moduleId;
                ContentService_1.default.lastCreatedModule = null;
            }
        }
    }, [location.pathname]);
};
exports.default = useClearLastModuleId;
